import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { Link as ScrollLink } from 'react-scroll';
import env from '../../../config/env';

const SectionAlternative = (props) => {
  const bgImage = `url(${env.url}${props.collection.image.path})`;
  return (
    <section id={props.sectionId} className={`spotlight ${props.sectionStyle}`} style={{ backgroundPosition: 'center center', backgroundImage: bgImage }}>
      <span className="image fit main"><img src={`${env.url}${props.collection.image.path}`} alt="" /></span>
      <div className="content">
        <header>
          <h2>{props.collection.title}</h2>
          <p>{props.collection.subtitle}</p>
        </header>
        <p dangerouslySetInnerHTML={{ __html: props.collection.content }}></p>
        {props.href &&
          <ul className="actions">
            <li>
              <Link to={props.href} className="button">
                Ver
          </Link>
            </li>
          </ul>
        }
      </div>
      <ScrollLink activeClass="active" className="goto-next scrolly" to={props.next} spy={true} smooth={true} offset={0}
        duration={500}>
        Next
      </ScrollLink>
    </section>

  );
};

export default SectionAlternative;

SectionAlternative.propTypes = {
  sectionId: PropTypes.string,
  sectionStyle: PropTypes.string,
  href: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/wrapper/section/SectionAlternative.js